interface ArticleVideoProps {
	src: string;
	/** Visible caption under the video - mandatory for docs (enforced by build-docs.mjs). */
	caption?: string;
	/** Falls back to the caption when no title is provided. */
	alt?: string;
}

const EXTENSION_MIME: Record<string, string> = {
	mp4: 'video/mp4',
	webm: 'video/webm',
	mov: 'video/quicktime',
	ogv: 'video/ogg',
	ogg: 'video/ogg',
};

const videoMimeFromUrl = (url: string): string => {
	const ext = url.split(/[?#]/)[0].split('.').pop()?.toLowerCase() ?? '';
	return EXTENSION_MIME[ext] ?? 'video/mp4';
};

/**
 * ArticleVideo — figure for video URLs in the article markdown renderer (docs +
 * blog). Mirrors ArticleImage's framed figure, but plays inline with native
 * HTML5 controls instead of opening a lightbox.
 */
export const ArticleVideo = ({ src, caption, alt }: ArticleVideoProps): React.JSX.Element => {
	const captionText = caption ?? alt;
	return (
		<figure className="my-6">
			<div className="overflow-hidden rounded-lg bg-neutral/[0.03]">
				<video controls preload="metadata" playsInline className="block w-full">
					<source src={src} type={videoMimeFromUrl(src)} />
				</video>
			</div>
			{captionText && (
				<figcaption className="mt-2.5 text-center text-[13px] leading-[1.5] text-neutral/40">
					{captionText}
				</figcaption>
			)}
		</figure>
	);
};
